import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
} from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'

export const ShowRemark = (props) => {
  const { open, toggle } = props
  const month = get(props, 'month')
  const lob = get(props, 'lob')
  const remark = get(props, 'remark')
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <HeaderForm toggle={ () => toggle() }>
          <HeadLabel>Remark</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container>
                    <Row>
                      <Title>Submitting Period</Title>
                    </Row>
                    <Row>
                      <Detail>{ month }</Detail>
                    </Row>
                    <Row>
                      <Title>LOB</Title>
                    </Row>
                    <Row>
                      <Detail>{ lob }</Detail>
                    </Row>
                    <Row>
                      <Title>Remarks</Title>
                    </Row>
                    <Row>
                      <Detail>{ remark }</Detail>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  )
}

ShowRemark.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
}
ShowRemark.defaultProps = {
  open: false,
  toggle: () => {},
}

const HeaderForm = styled(ModalHeader)`
  font-family: Gotham-Bold;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const Title = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 14px ;
  margin-left: 5px;
`
const Detail = styled(Label)`
  font-family: Gotham;
  font-size: 14px ;
  margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/form/show-remark.js